import { ContactsForUser } from '../../components/ContactsForUserEditor/ContactsForUserEditor';
import { BannerId } from '../../typings/banners';
import { ProtocolValue } from '../../typings/bannersEditState';
import { ValidationErrorsSet } from '../../typings/common';
import { ContactsEditorType } from '../../typings/domain';

export const UPDATE_BANNER_CONTACTS_FOR_USER =
    'UPDATE_BANNER_CONTACTS_FOR_USER';
export type UPDATE_BANNER_CONTACTS_FOR_USER = typeof UPDATE_BANNER_CONTACTS_FOR_USER;
export interface UpdateBannerContactsForUser {
    type: UPDATE_BANNER_CONTACTS_FOR_USER;
    bannerId: BannerId;
    contactsForUser: ContactsForUser;
}
export function updateBannerContactsForUser(
    bannerId: BannerId,
    contactsForUser: ContactsForUser
): UpdateBannerContactsForUser {
    return {
        type: UPDATE_BANNER_CONTACTS_FOR_USER,
        bannerId,
        contactsForUser
    };
}

export const UPDATE_HREF_BANNER_CONTACTS_FOR_USER =
    'UPDATE_HREF_BANNER_CONTACTS_FOR_USER';
export type UPDATE_HREF_BANNER_CONTACTS_FOR_USER = typeof UPDATE_HREF_BANNER_CONTACTS_FOR_USER;
export interface UpdateHrefBannerContactsForUser {
    type: UPDATE_HREF_BANNER_CONTACTS_FOR_USER;
    bannerId: BannerId;
    hrefValue: string;
}
export function updateHrefBannerContactsForUser(
    bannerId: BannerId,
    hrefValue: string
): UpdateHrefBannerContactsForUser {
    return {
        type: UPDATE_HREF_BANNER_CONTACTS_FOR_USER,
        bannerId,
        hrefValue
    };
}

export const UPDATE_BANNER_DISPLAY_DOMAIN = 'UPDATE_BANNER_DISPLAY_DOMAIN';
export type UPDATE_BANNER_DISPLAY_DOMAIN = typeof UPDATE_BANNER_DISPLAY_DOMAIN;
export interface UpdateBannerDisplayDomain {
    type: UPDATE_BANNER_DISPLAY_DOMAIN;
    bannerId: BannerId;
    domain: string;
}
export function updateBannerDisplayDomain(
    bannerId: BannerId,
    domain: string
): UpdateBannerDisplayDomain {
    return {
        type: UPDATE_BANNER_DISPLAY_DOMAIN,
        bannerId,
        domain
    };
}

export const UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN =
    'UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN';
export type UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN = typeof UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN;
export interface UpdateBannerContactsForUserDomain {
    type: UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN;
    bannerId: BannerId;
    contactsForUser: ContactsForUser;
}
export function updateBannerContactsForUserDomain(
    bannerId: BannerId,
    contactsForUser: ContactsForUser
): UpdateBannerContactsForUserDomain {
    return {
        type: UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN,
        bannerId,
        contactsForUser
    };
}

export const UPDATE_MAIN_LINK = 'UPDATE_MAIN_LINK';
export type UPDATE_MAIN_LINK = typeof UPDATE_MAIN_LINK;
export interface UpdateMainLink {
    type: UPDATE_MAIN_LINK;
    bannerId: BannerId;
    href: string;
}
export function updateMainLink(
    bannerId: BannerId,
    href: string
): UpdateMainLink {
    return {
        type: UPDATE_MAIN_LINK,
        bannerId,
        href
    };
}

export const UPDATE_BANNER_HREF_STATUS = 'UPDATE_BANNER_HREF_STATUS';
export type UPDATE_BANNER_HREF_STATUS = typeof UPDATE_BANNER_HREF_STATUS;
export interface UpdateBannerHrefStatus {
    type: UPDATE_BANNER_HREF_STATUS;
    bannerId: BannerId;
    isValid: boolean;
    text: string;
}
export function updateBannerHrefStatus(
    bannerId: BannerId,
    isValid: boolean,
    text: string
): UpdateBannerHrefStatus {
    return {
        type: UPDATE_BANNER_HREF_STATUS,
        bannerId,
        isValid,
        text
    };
}

export const CHECK_BANNER_HREF_STATUS = 'CHECK_BANNER_HREF_STATUS';
export type CHECK_BANNER_HREF_STATUS = typeof CHECK_BANNER_HREF_STATUS;
export interface CheckBannerHrefStatus {
    type: CHECK_BANNER_HREF_STATUS;
    bannerId: BannerId;
    href: string;
    isHrefChanged: boolean;
}
export function checkBannerHrefStatus(
    bannerId: BannerId,
    href: string,
    isHrefChanged: boolean
): CheckBannerHrefStatus {
    return {
        type: CHECK_BANNER_HREF_STATUS,
        bannerId,
        href,
        isHrefChanged
    };
}

export const CHANGE_MAIN_LINK_PROTOCOL = 'CHANGE_MAIN_LINK_PROTOCOL';
export type CHANGE_MAIN_LINK_PROTOCOL = typeof CHANGE_MAIN_LINK_PROTOCOL;
export interface ChangeMainLinkProtocol {
    type: CHANGE_MAIN_LINK_PROTOCOL;
    bannerId: BannerId;
    value: ProtocolValue;
}
export function changeMainLinkProtocol(
    bannerId: BannerId,
    value: ProtocolValue
): ChangeMainLinkProtocol {
    return {
        type: CHANGE_MAIN_LINK_PROTOCOL,
        bannerId,
        value
    };
}

export const CLEAR_MAIN_LINK_DOMAIN = 'CLEAR_MAIN_LINK_DOMAIN';
export type CLEAR_MAIN_LINK_DOMAIN = typeof CLEAR_MAIN_LINK_DOMAIN;
export interface ClearMainLinkDomain {
    type: CLEAR_MAIN_LINK_DOMAIN;
    bannerId: BannerId;
}
export function clearMainLinkDomain(bannerId: BannerId): ClearMainLinkDomain {
    return {
        type: CLEAR_MAIN_LINK_DOMAIN,
        bannerId
    };
}

export const CHANGE_CONTACTS_DESKTOP_TYPE_EDIT_BANNERS =
    'CHANGE_CONTACTS_DESKTOP_TYPE_EDIT_BANNERS';
export type CHANGE_CONTACTS_DESKTOP_TYPE_EDIT_BANNERS = typeof CHANGE_CONTACTS_DESKTOP_TYPE_EDIT_BANNERS;
export interface ChangeContactsDesktopTypeEditBannersAction {
    type: CHANGE_CONTACTS_DESKTOP_TYPE_EDIT_BANNERS;
    val: ContactsEditorType;
    bannerId: BannerId;
}

export function changeContactsDesktopTypeEditBanners(
    val: ContactsEditorType,
    bannerId: BannerId
): ChangeContactsDesktopTypeEditBannersAction {
    return {
        type: CHANGE_CONTACTS_DESKTOP_TYPE_EDIT_BANNERS,
        val,
        bannerId
    };
}

export const SHOW_BANNERS_CONTACTS_VALIDATION_ERROR =
    'SHOW_BANNERS_CONTACTS_VALIDATION_ERROR';
export type SHOW_BANNERS_CONTACTS_VALIDATION_ERROR = typeof SHOW_BANNERS_CONTACTS_VALIDATION_ERROR;
export interface ShowBannersContactsValidationError {
    type: SHOW_BANNERS_CONTACTS_VALIDATION_ERROR;
    error: ValidationErrorsSet;
}

export function showBannersContactsValidationError(
    error: ValidationErrorsSet
): ShowBannersContactsValidationError {
    return {
        type: SHOW_BANNERS_CONTACTS_VALIDATION_ERROR,
        error
    };
}

export const CHANGE_CONTACTS_MOBILE_TYPE_EDIT_BANNERS =
    'CHANGE_CONTACTS_MOBILE_TYPE_EDIT_BANNERS';
export type CHANGE_CONTACTS_MOBILE_TYPE_EDIT_BANNERS = typeof CHANGE_CONTACTS_MOBILE_TYPE_EDIT_BANNERS;
export interface ChangeContactsMobileTypeEditBannersAction {
    type: CHANGE_CONTACTS_MOBILE_TYPE_EDIT_BANNERS;
    val: ContactsEditorType;
    bannerId: BannerId;
}

export function changeContactsMobileTypeEditBanners(
    val: ContactsEditorType,
    bannerId: BannerId
): ChangeContactsMobileTypeEditBannersAction {
    return {
        type: CHANGE_CONTACTS_MOBILE_TYPE_EDIT_BANNERS,
        val,
        bannerId
    };
}

export type BannerContactsActions =
    | UpdateBannerContactsForUser
    | UpdateHrefBannerContactsForUser
    | UpdateBannerDisplayDomain
    | UpdateBannerContactsForUserDomain
    | UpdateMainLink
    | UpdateBannerHrefStatus
    | CheckBannerHrefStatus
    | ChangeMainLinkProtocol
    | ClearMainLinkDomain
    | ShowBannersContactsValidationError
    | ChangeContactsDesktopTypeEditBannersAction
    | ChangeContactsMobileTypeEditBannersAction;
